import {
  FileTextIcon,
  ZapIcon,
  ActivityIcon,
  SmartphoneIcon,
  ShieldCheckIcon,
  LockIcon,
  CreditCardIcon,
} from 'lucide-react';

export const heroChips = [
  { icon: FileTextIcon, label: '100% PDF' },
  { icon: ZapIcon, label: 'Ready to download' },
  { icon: ActivityIcon, label: 'All ages and levels' },
  { icon: SmartphoneIcon, label: 'Android & iOS' },
];

export const heroTrust = [
  { icon: ShieldCheckIcon, label: '7-Day Guarantee' },
  { icon: LockIcon, label: 'Secure Payment' },
  { icon: CreditCardIcon, label: 'Credit / Debit' },
  { icon: ZapIcon, label: 'Instant Access' },
];

export const stats = [
  { value: '500+', label: 'Happy professionals ⭐' },
  { value: '6', label: 'Complete volumes' },
  { value: '5', label: 'Bonuses included' },
  { value: '4.9/5', label: 'Rating' },
];
